const PIXI = require('pixi.js');
const Shortcuts = {};

Shortcuts.getSprite = (name, TextureCache, instanceName) => {
    const textures = TextureCache[name];
    const sp = new PIXI.Sprite(textures);
    sp.name = instanceName || name;
    return sp;
}

Shortcuts.getCenteredSpriteInCont = (name, TextureCache) => {
    const cloudImg = Shortcuts.getSprite(name, TextureCache, name + 'Img');
    cloudImg.anchor.set(0.5, 0.5);
    const cloudImgContainer = new PIXI.Container();
    cloudImgContainer.img = cloudImg;
    cloudImgContainer.addChild(cloudImg);
    return cloudImgContainer;
}

Shortcuts.addTo = (ch, name, parent) => {
    parent.addChild(ch);
    parent[name] = ch;
    ch.name = name;
    return ch;
}

Shortcuts.destroyTimeline = instance => {
    if (!instance.timeline) return;
    instance.timeline.kill();
    instance.timeline = null;
}

Shortcuts.rect = (g, x, y, w, h, color = void 0, borderColor = void 0, borderWidth = 1, borderAlpha = 1) => {
    if (borderColor !== void 0)
        g.lineStyle(borderWidth, borderColor, borderAlpha);
    if (color !== void 0)
        g.beginFill(color);
    g.drawRect(x, y, w, h);
    g.endFill();
}

Shortcuts.getRad = deg => {
    return deg / 180 * Math.PI;
}

module.exports = Shortcuts;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/utils/Shortcuts.js